const processUserAgent = ({ 'user-agent': userAgent, ...headers }) => {
  const ieCheck = () => {
    const posibilities = ['MSIE', 'Trident/'];
    return posibilities.some(pos => userAgent.includes(pos));
  };

  const touchUaCheck = () =>
    /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(userAgent) ||
    /\b(Android|Windows Phone|iPad|iPod)\b/i.test(userAgent);

  const touchCheck = () => {
    const isCloudFront = headers['cloudfront-is-mobile-viewer'] !== undefined;
    return isCloudFront
      ? headers['cloudfront-is-mobile-viewer'] === 'true'
      : touchUaCheck();
  };

  const edgeCheck = () => {
    const posibilities = ['Edg/', 'Edge/'];
    return posibilities.some(pos => userAgent.includes(pos));
  };

  return {
    userAgent,
    isTouch: touchCheck(),
    isIE: ieCheck(),
    isEdge: edgeCheck(),
    isAndroid: userAgent.includes('Android'),
  };
};

export default processUserAgent;
